<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="1100px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onAbort"
        @click:outside="onAbort"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Historia statusu
                </h1>
            </v-card-title>

            <v-card-text>
                <v-data-table
                    :headers="accidentHistoryHeaders"
                    :items="accidentStatusHistory"
                    hide-default-footer
                    fixed-header
                    :mobile-breakpoint="0"
                    name="accidentsHistoryData"
                >
                    <template #item.oldStatus="{item}">
                        {{ item.oldStatus.name }}
                    </template>
                    <template #item.comment="{item}">
                        {{ parseComment(item.comment) }}
                    </template>
                    <template #item.newStatus="{item}">
                        {{ item.newStatus.name }}
                    </template>
                    <template #item.user="{item}">
                        <template v-if="item.user.firstName && item.user.lastName">
                            {{ item.user.firstName }} {{ item.user.lastName }}
                        </template>
                        <template v-else>
                            {{ item.user.username }}
                        </template>
                    </template>
                    <template #item.createdAt="{item}">
                        {{ formatDate(item.createdAt) }}
                    </template>

                    <template slot="no-results" :value="true">
                        <p class="text-center">
                            Brak danych
                        </p>
                    </template>
                </v-data-table>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    @click="onAbort"
                >
                    Zamknij
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import dateFormatter from '@/mixins/dateFormatter'

export default {
    name: 'StatusHistoryDialog',
    mixins: [
        dateFormatter,
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        accidentStatusHistory: {
            type: Array,
            default: null
        },
    },
    data() {
        return {
            accidentHistoryHeaders: [
                {
                    text: 'Status przed',
                    value: 'oldStatus',
                    sortable: false,
                    align: 'center',
                    width: 180
                },
                {
                    text: 'Komentarz',
                    align: 'center',
                    sortable: false,
                    value: 'comment'
                },
                {
                    text: 'Status po',
                    align: 'center',
                    sortable: false,
                    value: 'newStatus',
                },
                {
                    text: 'Komentujący',
                    align: 'center',
                    sortable: false,
                    value: 'user'
                },
                {
                    text: 'Data utworzenia',
                    align: 'center',
                    sortable: false,
                    value: 'createdAt'
                }
            ]
        }
    },
    methods: {
        parseComment(value) {
            return value ? value : '-'
        },
        onAbort() {
            this.$emit('close-status-history-dialog')
        },
    }
}
</script>